import React, { FC } from 'react';
import { Line } from 'react-chartjs-2';
import {
  BarController,
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { colors } from '../../styles/tokens';
import { currency } from '../../utils';

ChartJS.register(
  BarController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  BarElement,
  Tooltip,
  Legend
);

interface ChartProps {
  chartData: any;
}

export const Chart: FC<ChartProps> = ({ chartData, ...rest }) => {
  const chartOptions = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback(value) {
            return currency(value);
          },
        },
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          boxWidth: 18,
          color: colors.black.default,
          font: {
            weight: 'bold',
            size: 14,
            lineHeight: 22,
          },
        },
      },
      tooltip: {
        callbacks: {
          label(context) {
            return currency(context.parsed.y);
          },
        },
      },
    },
  };

  return <Line data={chartData} options={chartOptions} {...rest} />;
};
